import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
} from '@material-ui/core';

import { SvgIcon } from '../../Base';

const useAccordionStyles = makeStyles({
  root: ({ accordionStylesProps }) => ({
    boxShadow: 'none',
    ...accordionStylesProps,
    '&:before': {
      display: 'none',
    },
  }),
  expanded: {
    '&$expanded': {
      margin: 0,
    },
  },
});

const useAccordionSummaryStyles = makeStyles({
  root: ({ accordionSummaryStylesProps }) => ({
    minHeight: '46px',
    ...accordionSummaryStylesProps,
  }),
  content: {
    '&$expanded': { margin: 0 },
  },
  expanded: {
    '&$expanded': { minHeight: 0 },
  },
});

const useAccordionDetailsStyles = makeStyles({
  root: ({ accordionDetailsStylesProps }) => ({
    display: 'block',
    padding: 0,
    ...accordionDetailsStylesProps,
  }),
});

const Accordion = ({
  title,
  children,
  accordionProps,
  accordionSummaryProps,
  accordionDetailsProps,
  accordionStylesProps,
  accordionSummaryStylesProps,
  accordionDetailsStylesProps,
}) => {
  const accordionClasses = useAccordionStyles({ accordionStylesProps });
  const accordionSummaryClasses = useAccordionSummaryStyles({
    accordionSummaryStylesProps,
  });
  const accordionDetailsClasses = useAccordionDetailsStyles({ accordionDetailsStylesProps });

  return (
    <MuiAccordion classes={accordionClasses} {...accordionProps}>
      <AccordionSummary
        classes={accordionSummaryClasses}
        expandIcon={<SvgIcon icon={SvgIcon.ICON_LIST.ARROW_UP} />}
        {...accordionSummaryProps}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails classes={accordionDetailsClasses} {...accordionDetailsProps}>
        {children}
      </AccordionDetails>
    </MuiAccordion>
  );
};

Accordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.element,
  defaultIsExpanded: PropTypes.bool,
  accordionProps: PropTypes.object,
  accordionSummaryProps: PropTypes.object,
  accordionDetailsProps: PropTypes.object,
  accordionStylesProps: PropTypes.object,
  accordionSummaryStylesProps: PropTypes.object,
  accordionDetailsStylesProps: PropTypes.object,
};

Accordion.defaultProps = {
  defaultIsExpanded: false,
};

export default Accordion;
